<template>
  <!--begin::Dashboard-->
  <div >
    <b-row >
      <b-col cols="4">
        <b-card class="card-custom gutter-b" no-body v-if="team">
          <b-card-body>
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-3"
            >
              <div class="logo">
                <img
                  :src="'https://api.xupxup.net/' + team.logo"
                  class="align-self-center"
                  style="width:100px"
                  alt
                />
              </div>
              <div class="">
                <h4 class="font-weight-bolder text-dark-75 text-right">
                  {{ team.name }}
                </h4>

                <!-- <div class="text-dark-50 font-weight-bold">Points</div> -->
                <div
                  class="font-weight-bolder font-size-h4 text-success text-right"
                  v-if="team.users"
                >
                  {{ puntsTeam }}
                </div>
              </div>
            </div>
            <profiles-team class="pt-1"></profiles-team>
          </b-card-body>
        </b-card>
      </b-col>
     
    </b-row>

    <b-row v-if="team">
      <b-col
        :cols="12 / team.users.length"
        v-for="u in team.users"
        :key="u._id"
      >
        <b-card no-body>
          <b-card-body>
            <team-member :user="u" />
            <active-projects :user="u._id" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="teams">
      <h1>All teams</h1>
    <b-row>
       <b-col cols="3" v-for="t in teams" :key="t._id">
        <b-card no-body>
        <b-card-body>
          <div >
            <div class="logo text-center">
              <img
                v-if="t.logo"
                :src="'https://api.xupxup.net/' + t.logo"
                alt=""
                  style="width:100px"
              />
            </div>
            <div class="team-title">
              <h2 class="text-center">
                {{ t.name }}
              </h2>
            </div>
           
            <div class="d-flex flex-column mt-10 members">
              <div class="d-flex flex-wrap justify-content-center">
                <div
                  class="symbol symbol-40 symbol-light-danger mr-3 mb-3"
                  v-for="u in t.users"
                  :key="u._id"
                >
                  <div class="symbol-label">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"
                          ><img
                            v-if="!u.avatar"
                            src="media/svg/avatars/001-boy.svg"
                            width="40px"
                            alt=""/>
                          <img
                            v-if="u.avatar"
                            :src="'https://api.xupxup.net/' + u.avatar"
                            width="40px"
                            alt=""
                        /></span>
                      </template>
                      <span>{{ u.firstName }} {{ u.lastName }}</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

        <!--end::Body-->
        <!--end::Mixed Widget 7-->
      </b-col>
    </b-row>
    </div>
  </div>

  <!--end::Dashboard-->
</template>
<style lang="scss" scoped>
.teams{
  background-color: gray;
  width:100vw;
  transform: translateX(-25px);
  padding:100px 25px;
  margin-top:100px;
  h1 {
    text-align: center;
    padding-bottom: 50px;
    color: white;
  }
}
.team-title h2 {
  margin-top: 25px;
  font-size: 16px;
  font-weight: 600;
}
.team-title a {
  color: black;
}
.logo {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo img {
  width: auto;
  
  max-width: 100%;
  height: auto;
}
.members .symbol.symbol-light-danger .symbol-label {
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.members img {
  border-radius: 3px;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ProfilesTeam from "../layout/dashboard/ProfilesTeam.vue";
import TeamMember from "../layout/dashboard/TeamMember.vue";
import ActiveProjects from "../layout/dashboard/ActiveProjects.vue";

export default {
  components: { ProfilesTeam, TeamMember, ActiveProjects },
  name: "teams",

  data() {
    return {
      hover: false
    };
  },

  computed: {
    teams() {
      return this.$store.getters.getTeams;
    },
    team() {
      return this.$store.getters.getMyTeam||this.teams[0];
    },
    puntsTeam() {
      let total = 0;

      this.team?.users.forEach(function(u) {
        total += u.points.total;
      });
      return total;
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Teams" }]);
  },
  methods: {}
};
</script>
